<template>
  <div>
    <v-card class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
      <iframe :src="getIframeSource" frameborder="0" width="100%" height="700"></iframe>
    </v-card>
  </div>
</template>

<script>

export default {
  props: ["pdf"],
  name: "PDFViewer",
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getIframeSource() {
      return this.getApiUrl + "/" + this.pdf;
    }
  }
};
</script>

<style>
</style>